import EditorFeatureTitle from "../../components/editor/EditorFeatureTitle";
import EditorFeatureSubtitle from "../../components/editor/EditorFeatureSubtitle";
import wrtingStyleProfile from "../../assets/svg/wrtingStyleProfile.svg";

const WritingStyleReport = () => {
	return (
		<div className="bg-white shadow-sm lg:p-9 xl:p-9 2xl:p-10 flex flex-col overflow-hidden">
			<EditorFeatureTitle title="Writing Style Report" />
			<EditorFeatureSubtitle>
				<div className="">
					<span>We found</span>
					<span className="bg-ef bg-opacity-20 font-bold text-xl px-1 ml-1 mr-2 shadow-inner-lg drop-shadow-lg  text-ef">
						35%
					</span>
					<span>
						similarity between your writing style and{" "}
						<span className="font-extrabold">George R. R. Martin’s.</span>
					</span>
				</div>
			</EditorFeatureSubtitle>
			<div className='flex-1 scrollbar-y-2 pr-5 -mr-5 lg:mt-7 xl:mt-8 2xl:mt-9'>
				<div className="px-7 py-6 md:py-4  bg-f0 rounded-10 flex space-x-5">
					<img
						className="rounded-100 w-24 h-24 md:w-16 md:h-16 "
						src={wrtingStyleProfile}
						alt="Brand logo"
					/>
					<div className="my-auto">
						<span className="text-2xl font-bold md:text-xl leading-none">
							George R. R. Martin
						</span>{" "}
						<span className="ml-2 text-base text-ef font-bold underline pb-2">
							view profile
						</span>{" "}
						<br />
						<span className="text-xl md:text-lg">American Novelist</span>
					</div>
				</div>
				<div className="lg:space-y-4 2xl:space-y-5 md:mt-5 lg:mt-7 xl:mt-8 2xl:mt-9">
					<div className=" lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center">
						<div className="flex justify-between w-full text-xl font-bold mb-3 md:2">
							<div>Precision</div>
							<div>53%</div>
						</div>
						<div className="relative bg-7d rounded-full md:h-3 h-4 flex-1 bg-opacity-20">
							<div className="absolute inset-y-0 left-0 w-53 bg-06 rounded-full"></div>
						</div>
					</div>
					<div className=" lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center">
						<div className="flex justify-between w-full text-xl font-bold mb-3 md:2">
							<div>Point of View</div>
							<div>25%</div>
						</div>
						<div className="relative bg-7d rounded-full md:h-3 h-4 flex-1 bg-opacity-20">
							<div className="absolute inset-y-0 left-0 w-1/4 bg-ef rounded-full"></div>
						</div>
					</div>
					<div className=" lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center">
						<div className="flex justify-between w-full text-xl font-bold mb-3 md:2">
							<div>Attention to detail</div>
							<div>53%</div>
						</div>
						<div className="relative bg-7d rounded-full md:h-3 h-4 flex-1 bg-opacity-20">
							<div className="absolute inset-y-0 left-0 w-1/10 bg-ffa rounded-full"></div>
						</div>
					</div>
					<div className=" lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center">
						<div className="flex justify-between w-full text-xl font-bold mb-3 md:2">
							<div>Rhythm</div>
							<div>53%</div>
						</div>
						<div className="relative bg-7d rounded-full md:h-3 h-4 flex-1 bg-opacity-20">
							<div className="absolute inset-y-0 left-0 w-75 bg-6A rounded-full"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default WritingStyleReport;
